<template>
  <div class="workspace_wrap">
    <div class="carVR_top box">
      <i class="el-icon-warning yellow"></i>
      <span class="cardVR_top_t yellow">企业标签将显示在您企业名下所有员工的名片中，最多8个标签。</span>
    </div>
    <div class="card_labels box">
      <div class="card_label_title">企业标签</div>
      <div>
        <el-tag
                :key="tag.id"
                v-for="(tag,idx) in dynamicTags"
                closable
                :disable-transitions="false"
                @close="handleClose(idx,tag.id)"
        >{{tag.name}}
        </el-tag>
        <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
        ></el-input>
        <el-button class="button-new-tag" size="small" @click="showInput" v-if="dynamicTags.length<8">+ 新建标签</el-button>
      </div>
      <div class="card_consult" v-if="ReferenceLabel.length>0">
        <div :class="idx>0?'mt20':''" v-for="(itema,idx) in ReferenceLabel" :key="idx">
          <div class="card_label_title">{{itema.name}}</div>
          <el-tag type="info" v-for="(item,index) in itema.lab" :key="index" class="linetages" @click="addLeabel(item.name)">
            {{item.name}}
          </el-tag>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "cardTags",
    data() {
      return {
        dynamicTags: [],
        ReferenceLabel: [],
        inputVisible: false,
        inputValue: ""
      };
    },
    created() {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
      });
      this.InitFn(loading)
      this.getLabel()
    },
    methods: {
      InitFn(loading) {
        this.axios
            .post(api.tags_index, {})
            .then(response => {
              if (response.data.code == 0) {
                this.dynamicTags = response.data.tags
                loading.close();
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 参考标签
      getLabel() {
        this.axios
            .post(api.tags_getLabel, {})
            .then(response => {
              if (response.data.code == 0) {
                this.ReferenceLabel = response.data.label;
              } else {
              }
            })
            .catch(response => {
            });
      },      
      handleClose(tag, id) {
        this.axios
            .post(api.tags_delete, {tag_id: id})
            .then(response => {
              if (response.data.code == 0) {
                this.dynamicTags.splice(tag, 1);
              } else {
              }
            })
            .catch(response => {
            });
      },

      showInput() {
        this.inputVisible = true;
        this.$nextTick(() => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          let state = 0
          for (let i in this.dynamicTags) {
            if (this.dynamicTags[i].name === inputValue) {
              state = 1
            }
          }
          if (state === 1) {
            this.$message({
              message: '标签已经存在',
              type: 'warning'
            });
            return
          }
          let newList = {}
          newList.name = inputValue
          this.changeAddLeabel(newList)
        }
        this.inputVisible = false;
        this.inputValue = "";
      },
      addLeabel(name) {
        let state = 0
        for (let i in this.dynamicTags) {
          if (this.dynamicTags[i].name === name) {
            state = 1
          }
        }
        if (state === 1) {
          this.$message({
            message: '标签已经存在',
            type: 'warning'
          });
          return
        }
        let newList = {}
        newList.name = name
        this.changeAddLeabel(newList)
      },
      changeAddLeabel(obj) {
        this.axios
            .post(api.tags_set, {tags: [...this.dynamicTags,obj]})
            .then(response => {
              if (response.data.code == 0) {
                this.InitFn()
              } else {
              }
            })
            .catch(response => {
            });
      }
    }
  };
</script>
